import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export interface ConfirmationDialogData {
  action: 'approve' | 'block' | 'reject';
  isMultiple: boolean;
  role:string;
  acronym:string;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {
  form: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData,
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      comment: [''],
      onBehalf: [false]
    });


    console.log(JSON.stringify(data));
    
  
    // Set validators only if action is 'reject' or 'block'
    if (this.data.action === 'reject' || this.data.action === 'block') {
      this.form.get('comment').setValidators([Validators.required]);
      this.form.get('comment').updateValueAndValidity();
    
      const isFocalAndCoursera = this.data.role === 'FOCAL_PERSON' && this.data.acronym === 'COURSERA';
    
      if (!isFocalAndCoursera) {
        this.form.get('onBehalf').setValidators([Validators.requiredTrue]);
      } else {
        this.form.get('onBehalf').clearValidators();
        this.form.get('onBehalf').setValue(false); // optionally reset the checkbox
      }
    
      this.form.get('onBehalf').updateValueAndValidity();
    }
    
  }

  submit(): void {
    if (this.data.action === 'approve') {
      this.dialogRef.close({});
    } else if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    }
  }

}
